const validationsEN = {
  passwordLengthRestriction: 'Password must be at least 8 characters',
  containsCapitalSmallLetter: 'Password must have at least one uppercase and one lowercase letters',
  containsNumber: 'Password must have at least one number',
  containsSpecialCharacter: 'Password must have at least one special character [., ! @ # ? ]',
  confirmPasswordEmptyField: 'Confirm Password is Required',
  passwordsNotMatched: "Password doesn't match",
  serviceError: 'Something went wrong, Retry',
  emailEmptyField: 'Please enter your email',
  passwordEmptyField: 'Please enter your password',
  notFoundEmail: 'Please enter a valid Email Address',
  invalidEmail: 'Please enter a valid email address',
  invalidPhoneNumber: 'Please enter a valid Phone Number',
  phoneNumberEmptyField: 'Phone Number is required',
  incorrectPassword: 'Please enter a valid password',
  firstNameEmptyField: 'First Name is Required',
  lastNameEmptyField: 'Last Name is Required',
  jobTitleEmptyField: 'Job Title is Required',
  companyNameEmptyField: 'Company Name is Required',
  reasonsForUsingPlatformEmptyField: 'Reasons for using platform is Required',
  codeInvalidInput: 'Invalid code.  Please try again',
  codeEmptyInput: 'Please insert the 2FA login code',
  invalidCredentials: 'Invalid credentials',
  invalidPhone: 'Invalid phone number',
  invalidJobTitle: 'Job title is required',
};

export default validationsEN;
